const universalBOM = '\uFEFF';

const FORMULA_PREFIXES = ['=', '+', '-', '@', '\t', '\r'];

export function escapeCsvField(field: string): string {
  let sanitized = field;
  if (FORMULA_PREFIXES.some((p) => sanitized.startsWith(p))) {
    sanitized = `'${sanitized}`;
  }
  return sanitized.includes(',') || sanitized.includes('"') || sanitized.includes('\n')
    ? `"${sanitized.replace(/"/g, '""')}"`
    : sanitized;
}

function getBlobType(extension: string): string {
  switch (extension.toLowerCase()) {
    case 'txt':
      return 'text/plain;charset=utf-8;';
    case 'csv':
      return 'text/csv;charset=utf-8;';
    case 'pdf':
      return 'application/pdf';
    case 'png':
      return 'image/png';
    default:
      return 'application/octet-stream'; // Fallback for unknown types
  }
}

export function downloadFile(data: BlobPart, type: string, fileName: string) {
  const blob = new Blob([data], { type: getBlobType(type) });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.${type}`;
  link.click();
  URL.revokeObjectURL(link.href);
}

export function downloadCsv(fileName: string, rows: string[]) {
  const csvContent = universalBOM + rows.join('\n');
  downloadFile(csvContent, 'csv', fileName);
}
